// shadcn-convention class-joining helper for the chat surface's Tailwind
// components. Spectrum's style() macro never needed this (it composes styles
// declaratively); the chat surface is a genuinely new, scoped need.
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
